import { Col, Row } from "reactstrap";
import LineItems from "./LineItems";
import Expenses from "./Expenses";
import Subcontracts from "./Subcontracts";

export default function LineItemsTab() {
  return (
    <>
      <Row className="g-3 mt-0">
        <Col>
          <LineItems />
          <Expenses />
          <Subcontracts />
        </Col>
      </Row>
    </>
  );
}
